import React from 'react'
import Box from '@mui/material/Box'
import Fields from '../Fields/Fields'
import UserInfo from '../Modules/User/UserInfo'
import TextValue from '../../../../text/TextValue'
import LearningContinuumFields from '../Modules/LearningContinuum/LearningContinuumFields'
import { getValueElement } from '../TableCompare/utils'
import CardsInformation from '../Modules/DevelopmentalRubric/CardsInformation'
import BasicInformation from '../Modules/Classes/BasicInformation'
import TextNotAssigned from '../../../../text/TextNotAssigned'
import BasicInformationEvidenceOfLearning from '../Modules/EvidenceOfLearning/BasicInformationEvidenceOfLearning'

const PreviewUpdated = ({ form }) => {
  let title = <TextValue title='Name' value={form?.detail?.name} />

  if (form.module === 'user') {
    title = <UserInfo user={form?.detail} />
  }
  if (form.module === 'growth goals') {
    title = (
      <div className='grid grid-cols-2 my-2 gap-2'>
        <TextValue title='Developmental rubric' value={form?.detail?.dr} />
        <TextValue title='Question' value={form?.detail?.name} />
      </div>
    )
  }
  if (form.module === 'learning continuum') {
    return (
      <Box>
        <TextValue title='Curriculum' value={form?.detail?.curriculum || <TextNotAssigned />} />
        <div className='py-1' />
        <LearningContinuumFields changes={form?.detail?.change} detail={form.detail} />
      </Box>
    )
  }
  if (form.module === 'developmental rubric') {
    return (
      <Box>
        <TextValue title='Curriculum' value={form?.detail?.curriculum || <TextNotAssigned />} />
        <div className='py-1' />
        <CardsInformation detail={form.detail} />
        <div className='py-1' />
        <Fields changes={form?.detail?.change} action={form.action} />
      </Box>
    )
  }

  if (form.module === 'class') {
    return (
      <Box>
        <TextValue title='Curriculum' value={form?.detail?.curriculum || <TextNotAssigned />} />
        <div className='py-1' />
        <BasicInformation detail={form.detail} />
        <div className='py-1' />
        <Fields changes={form?.detail?.change} action={form.action} />
      </Box>
    )
  }

  if (['evidence of learning', 'note of progress', 'note'].includes(form.module)) {
    return (
      <Box>
        <TextValue title='Curriculum' value={form?.detail?.curriculum || <TextNotAssigned />} />
        <div className='py-1' />
        {form?.detail?.student && (
          <>
            <TextValue
              title='stuent'
              value={
                <UserInfo user={form?.detail?.student} size='small' variant='circle' /> || <TextNotAssigned />
              }
            />

            <div className='py-1' />
          </>
        )}
        <BasicInformationEvidenceOfLearning detail={form.detail} />
        <div className='py-1' />

        <Fields changes={form?.detail?.change} action={form.action} />
      </Box>
    )
  }

  if (form.module.indexOf('curriculum') > -1) {
    let value = form?.detail?.name
    if (form?.detail?.curriculum) {
      value = (
        <div>
          <p>{form?.detail?.name}</p>
          <p className='text-xs'>{form?.detail?.curriculum}</p>
        </div>
      )
    }
    if (form?.detail.parent) {
      title = (
        <div className='grid grid-cols-2 mt-2'>
          <TextValue title='Name' value={form?.detail?.name} />
          <TextValue title='Parent' value={getValueElement(form?.detail?.parent, 'parent')} />
        </div>
      )
    } else {
      title = <TextValue title='Curriculum' value={value} />
    }
  }

  if (['data-entry assessment template', 'data-entry survey template'].includes(form.module)) {
    title = <TextValue title='Template' value={form?.detail?.title || form?.detail?.name} />
  }

  if (form.module == 'data-entry survey') {
    return (
      <Box>
        <TextValue title='Survey Name' value={form?.detail?.name} />
        <div className='py-1' />
        <Fields changes={form?.detail?.change} action={form.action} />
      </Box>
    )
  }

  if (form.module == 'data-entry assessment') {
    return (
      <Box>
        <TextValue title='Assessment Name' value={form?.detail?.name} />
        <div className='py-1' />
        <Fields changes={form?.detail?.change} action={form.action} />
      </Box>
    )
  }

  if (form.module == 'data-entry my surveys') {
    title = <TextValue title='Survey Name' value={form?.detail?.survey?.name || ''} />
  }

  if (form.module == 'data-entry assessment marking') {
    title = (
      <TextValue
        title='Assessment Name'
        value={
          form?.detail?.change?.newValues?.assessmentMarking &&
          form.detail.change.newValues.assessmentMarking.length > 0
            ? form.detail.change.newValues.assessmentMarking[0]?.assessment?.name || ''
            : ''
        }
      />
    )
  }

  return (
    <Box>
      {title}
      <div className='py-1' />
      <Fields changes={form?.detail?.change} action={form.action} />
    </Box>
  )
}

export default PreviewUpdated
